export const pageContent = {
    resources: {
        delivery: [
          { list: 'What is order', path: 'resourcescategory/order' },
          {
            list: 'What are the types of delivery and delivery times for an order?',
            path: 'resourcescategory/2',
          },
          { list: 'Updating delivery address', path: 'resourcescategory/3' },
          { list: 'Can i cancel my order?', path: 'resourcescategory/4' },
          {
            list: 'What should i do if i have not received all the items in my purchase?',
            path: 'resourcescategory/5',
          },
        ],
        return: [
          { list: 'Return & exchange policy', path: 'resourcescategory/6' },
          {
            list: 'How to return',
            path: 'resourcescategory/7',
          },
          { list: 'Track my return', path: 'resourcescategory/8' },
          { list: 'Return shipping costs', path: 'resourcescategory/9' },
          {
            list: 'Request a return form',
            path: 'resourcescategory/10',
          },
        ],
        online: [
          { list: 'How can I figure out my size', path: 'resourcescategory/11' },
          {
            list: 'Can a store ship out an item if there is no online inventory?',
            path: 'resourcescategory/12',
          },
          { list: 'Does sizing differ online and in-store?', path: 'resourcescategory/13' },
        ],
        store: [
          { list: 'Where is my nearest store?', path: 'resourcescategory/14' },
          {
            list: 'How do I contact a store directly?',
            path: 'resourcescategory/15',
          },
        ],
        products: [
          { list: 'My size assist', path: 'resourcescategory/16' },
          {
            list: 'How to measure',
            path: 'resourcescategory/17',
          },
          {
            list: 'About unisex clothing',
            path: 'resourcescategory/18',
          },
        ],
        
      },
      cards : [
        {
          icon: '👤',
          title: 'Pre-visit inquiries',
          hours: 'Mon-Fri\n9:30 AM to 6:00 PM Pacific',
          email: 'support@site.com',
          phone: '(042) 8364913'
        },
        {
          icon: '📋',
          title: 'Billing questions',
          hours: 'Mon-Fri\n9:30 AM to 5:00 PM Pacific',
          email: 'billing@site.com',
          phone: '(042) 1009222'
        },
        {
          icon: '💬',
          title: 'Sales questions',
          hours: 'Mon-Fri\n9:30 AM to 6:00 PM Pacific',
          email: 'sales@site.com',
          phone: '(042) 3383314'
        }
      ],
      teams: [
        {name:'Temi Ogundare', position:'CEO / Founder', image:'https://plasma-astro-template.vercel.app/images/about/team/1.webp'},
        {name:'Favour Chukuemeka', position:'CTO / Founder', image:'https://plasma-astro-template.vercel.app/images/about/team/3.webp'},
        {name:'Jason Addy', position:'Project Lead', image:'https://plasma-astro-template.vercel.app/images/about/team/4.webp'},
        {name:'Asemokhe Courage', position:'Software engineer', image:'https://plasma-astro-template.vercel.app/images/about/team/2.webp'}
      ]
}